import Loadable from '../../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "consumer-technologies-agile-hand" */ './index')
);
